import React from 'react';
import { getLogoSrc } from '../utils/logoHelper';
import { formatGameDate } from '../utils/dateFormatter';
import './GraphicRecapBold.css';
import api from '../services/api';

const API_BASE_URL = api.defaults.baseURL.replace('/api', '');

function GraphicRecapBold({
  graphicData,
  teamSport,
  teamColors,
  backgroundStyle = 'linear-gradient',
  homeTeamLogo,
  awayTeamLogoPreview,
  showWatermark = true,
  dateFormat = 'full',
}) {
  const {
    homeTeam,
    homeScore,
    awayTeam,
    awayScore,
    gameDate,
    topPerformer,
    topPerformerStats,
  } = graphicData;

  const homeWon = parseInt(homeScore) > parseInt(awayScore);
  const isTie = parseInt(homeScore) === parseInt(awayScore);

  const getBackgroundStyle = () => {
    switch (backgroundStyle) {
      case 'linear-gradient':
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'radial-gradient':
        return `radial-gradient(circle at center, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'diagonal-gradient':
        return `linear-gradient(45deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'split-two-tone':
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.primary} 50%, ${teamColors.secondary} 50%, ${teamColors.secondary} 100%)`;
      case 'solid-primary':
        return teamColors.primary;
      case 'solid-secondary':
        return teamColors.secondary;
      default:
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
    }
  };

  const isLightColor = (color) => {
    if (!color || color === 'null') return false; // Default to dark if color is null/undefined
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155;
  };

  const getBadgeColor = () => {
    const primaryLight = isLightColor(teamColors.primary);
    const secondaryLight = isLightColor(teamColors.secondary);

    if ((primaryLight && secondaryLight) || secondaryLight) {
      return '#2d3748';
    }
    return '#ffffff';
  };

  const getAwayTeamColor = () => {
    if (isLightColor(teamColors.secondary)) {
      return isLightColor(teamColors.primary) ? '#2d3748' : teamColors.primary;
    }
    return teamColors.secondary;
  };

  return (
    <div className="graphic-recap-bold" id="graphic-recap">
      {/* Header */}
      <div
        className="recap-bold-header"
        style={{ background: getBackgroundStyle() }}
      >
        <div className="recap-bold-logo">
          {homeTeamLogo ? (
            <div className="team-logo-circle team-logo-circle-sm">
              <img
                src={getLogoSrc(homeTeamLogo, API_BASE_URL)}
                alt={homeTeam}
                className="recap-bold-logo-img"
              />
            </div>
          ) : (
            <div className="team-logo-circle team-logo-circle-sm">
              {teamSport === 'Softball' ? '🥎' : '⚾'}
            </div>
          )}
        </div>
        <div className="recap-bold-badge" style={{ color: getBadgeColor() }}>
          {isTie ? 'TIE GAME' : homeWon ? 'VICTORY!' : 'FINAL SCORE'}
        </div>
      </div>

      {/* Main content - Score and teams */}
      <div className="recap-bold-content">
        <div className="recap-bold-score-display">
          <span style={{ color: teamColors.primary }}>{homeScore || '0'}</span>
          <span className="recap-bold-score-divider">-</span>
          <span style={{ color: getAwayTeamColor() }}>{awayScore || '0'}</span>
        </div>

        <div
          className="recap-bold-team-name home"
          style={{ color: teamColors.primary }}
        >
          {homeTeam || 'YOUR TEAM'}
        </div>

        <div className="recap-bold-versus">VS</div>

        <div
          className="recap-bold-team-name away"
          style={{ color: getAwayTeamColor() }}
        >
          {awayTeam || 'OPPONENT'}
        </div>

        {topPerformer && (
          <div className="recap-bold-performer">
            <div className="recap-bold-performer-label">
              ⭐ PLAYER OF THE GAME
            </div>
            <div className="recap-bold-performer-name">{topPerformer}</div>
            {topPerformerStats && (
              <div className="recap-bold-performer-stats">
                {topPerformerStats}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        className="recap-bold-footer"
        style={{ borderTop: `4px solid ${teamColors.primary}` }}
      >
        {gameDate && (
          <div className="recap-bold-date">{formatGameDate(gameDate, dateFormat)}</div>
        )}
        {showWatermark && (
          <div className="playmaker-watermark">
            <img src="/PMlogoleft.png" alt="Playmaker Media Kit" />
          </div>
        )}
      </div>
    </div>
  );
}

export default GraphicRecapBold;
